<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/program-p1"
                flat
                color="transparent"
                style="width: 50%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah {{ form.type }}
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text
                  class="pt-2">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <v-tabs
                          v-model="form.type_index"
                          dense
                          slider-size="5"
                          :color="set_color">
                          <v-tab
                            v-for="(item, index) in menu"
                            :key="index"
                            @click="form.type = item; form.program_id  = ''; form.kegiatan_id  = ''; form.par_id  = '';">
                            <span
                              class="body-2 font-weight-bold text-capitalize">
                              {{ item }}
                            </span>
                          </v-tab>
                        </v-tabs>
                      </div> -->

                      <v-row>
                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider 
                            name="Tahun Anggaran" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              
                              Tahun Anggaran
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. 2023"
                              :readonly="$route.query.kegiatan_id !== undefined && $route.query.kegiatan_id !== ''"

                              hide-details

                              :items="years"
                              :item-color="set_color"

                              @change="form.tahun_anggaran_id = ''; form.status_dpa = ''; form.anggaran_before = 0; fetchProgram(); fetchDpa();"

                              v-model="form.tahun_anggaran"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.tahun_anggaran !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="9">
                          <ValidationProvider 
                            name="Keterangan Tahun Anggaran" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Keterangan Tahun Anggaran
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Anggaran tahun 2024 untuk penyusunan perencanaan perangkat daerah"

                              hide-details

                              v-model="form.tahun_anggaran_text"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.tahun_anggaran_text !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      
                      <v-row v-if="form.type !== 'Program'">
                        <v-col
                          cols="12"
                          :md="form.type_index === 2 ? 6 : 12">
                          <ValidationProvider 
                            name="Program"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Program
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Program Penunjang Urusan"
                              :readonly="$route.query.kegiatan_id !== undefined && $route.query.kegiatan_id !== ''"

                              hide-details

                              :items="list.program"
                              item-text="title"
                              item-value="id"
                              :item-color="set_color"

                              @change="form.kegiatan_id  = ''; fetchKegiatan();"

                              v-model="form.program_id"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.program_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>

                          <!-- <div>
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Program / Kegiatan / Sub Kegiatan
                            </div>

                            <v-menu
                              ref="selectprogram"
                              min-width="625px"
                              max-width="625px"
                              transition="scale-transition"
                              offset-y
                              :close-on-content-click="false"
                              v-model="select_program">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Program / Kegiatan / Sub Kegiatan"
                                  rules="required"  
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    readonly
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Contoh. Perencanaan Anggaran"

                                    hide-details

                                    clearable
                                    @click:clear="form.par_name = ''"

                                    v-on="on"
                                    v-bind="attrs"

                                    v-model="form.par_name"
                                    :success="form.par_name !== '' && valid"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="form.par_name !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-list>
                                <v-list-item>
                                  <v-treeview
                                    dense
                                    open-on-click

                                    activatable
                                    :color="set_color"

                                    expand-icon
                                    rounded
                                    transition

                                    :items="list.program"
                                    item-key="id"
                                    item-text="title"

                                    item-children="children"

                                    return-object
                                    @update:active="to_value"

                                    class="custom_treeview">
                                    <template v-slot:prepend="{ item, open }">
                                      <v-icon v-if="item.children">
                                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                      </v-icon>

                                      <v-icon v-else
                                        small>
                                        mdi-rhombus-split
                                      </v-icon>
                                    </template>
                                  </v-treeview>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div> -->
                        </v-col>

                        <v-col v-if="form.type !== 'Program' && form.type !== 'Kegiatan'"
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Kegiatan"
                            rules="required"  
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Kegiatan
                            </div>

                            <v-autocomplete
                              v-on:keyup.enter="save()"

                              filled
                              rounded
                              dense

                              :color="set_color"
                              :readonly="$route.query.kegiatan_id !== undefined && $route.query.kegiatan_id !== ''"
                              placeholder="Contoh. Perencanaan, Penganggaran dan Evaluasi"

                              hide-details

                              :items="list.kegiatan"
                              item-text="title"
                              item-value="id"
                              :item-color="set_color"

                              v-model="form.kegiatan_id"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.kegiatan_id !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Kode" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Kode
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Contoh. 1.03.01XXX"
                              
                              hide-details

                              v-model="form.code"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.code !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="12">
                          <ValidationProvider 
                            name="Judul" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Judul
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Penyusunan Dokumen Perencanaan Perangkat Daerah"

                              hide-details

                              v-model="form.title"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.title !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <div
                            class="body-2 font-weight-bold black--text">
                            #Anggaran
                          </div>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.anggaran_before > 0">
                        <v-col
                          cols="12"
                          md="12">
                          <v-card
                            flat
                            color="#ff980026"
                            class="pa-3"
                            style="border: 2px dashed orange; border-radius: 10px;">
                            <div
                              class="line-text-second">
                              <div>
                                Nominal anggaran tidak boleh melebihi
                              </div>

                              <div>
                                pagu anggaran "{{ form.type === 'Kegiatan' ? 'Program' : 'Kegiatan' }}" sebesar : <span class="body-1 font-weight-bold black--text">{{ Number(form.anggaran_before) | price }}</span>
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-row>
                        <!-- <v-col
                          cols="12"
                          md="4">
                          <ValidationProvider
                            name="Nominal Anggaran (RENJA)" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Nominal Anggaran (RENJA)
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 120.000.000"

                              hide-details

                              v-model="form.anggaran"
                              :success="form.anggaran !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.anggaran !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col> -->

                        <v-col
                          cols="12"
                          md="4">
                          <ValidationProvider
                            name="Nominal Anggaran P1" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Nominal Anggaran P1
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 120.000.000"

                              hide-details

                              v-model="form.anggaran_p1"
                              :success="form.anggaran_p1 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.anggaran_p1 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <!-- <v-col
                          cols="12"
                          md="4">
                          <ValidationProvider
                            name="Nominal Anggaran (PERUBAHAN)" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              Nominal Anggaran (PERUBAHAN)
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 150.000.000"

                              hide-details

                              v-model="form.anggaran_perubahan"
                              :success="form.anggaran_perubahan !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.anggaran_perubahan !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col> -->
                      </v-row>

                      <v-row v-if="form.type === 'Sub Kegiatan'">
                        <v-col
                          cols="12"
                          md="3"
                          class="pb-2">
                          <v-btn
                            @click="show_anggaran = !show_anggaran ? true : false"
                            block
                            height="40"
                            color="#f0f0f0"
                            elevation="0"
                            class="body-2 font-weight-bold text-capitalize black--text d-flex align-center"
                            style="border-radius: 10px;">
                            <span>
                              #Target Keuangan Bulanan
                            </span>

                            <v-spacer />

                            <v-icon 
                              color="black">
                              {{ !show_anggaran ? 'mdi-menu-down' : 'mdi-menu-up' }}
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.type === 'Sub Kegiatan' && show_anggaran">
                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Januari" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Januari
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_1"
                              :success="form.target_keu_1 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_1 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Februari" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Februari
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_2"
                              :success="form.target_keu_2 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_2 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Maret" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Maret
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_3"
                              :success="form.target_keu_3 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_3 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="April" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              April
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_4"
                              :success="form.target_keu_4 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_4 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Mei" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Mei
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_5"
                              :success="form.target_keu_5 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_5 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Juni" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Juni
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_6"
                              :success="form.target_keu_6 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_6 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Juli" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Juli
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_7"
                              :success="form.target_keu_7 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_7 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Agustus" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Agustus
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_8"
                              :success="form.target_keu_8 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_8 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="September" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              September
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_9"
                              :success="form.target_keu_9 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_9 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Oktober" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Oktober
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_10"
                              :success="form.target_keu_10 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_10 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="November" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              November
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_11"
                              :success="form.target_keu_11 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_11 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Desember" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Desember
                            </div>

                            <v-currency-field
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              :min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10.000.000"

                              hide-details

                              v-model="form.target_keu_12"
                              :success="form.target_keu_12 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_keu_12 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.type === 'Sub Kegiatan'">
                        <v-col
                          cols="12"
                          md="3"
                          class="mt-1 pb-2">
                          <v-btn
                            @click="show_fisik = !show_fisik ? true : false"
                            block
                            height="40"
                            color="#f0f0f0"
                            elevation="0"
                            class="body-2 font-weight-bold text-capitalize black--text d-flex align-center"
                            style="border-radius: 10px;">
                            <span>
                              #Target Fisik Bulanan
                            </span>

                            <v-spacer />

                            <v-icon 
                              color="black">
                              {{ !show_fisik ? 'mdi-menu-down' : 'mdi-menu-up' }}
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-row v-if="form.type === 'Sub Kegiatan' && show_fisik">
                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Januari" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Januari
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_1"
                              :success="form.target_fisik_1 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_1 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Februari" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Februari
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_2"
                              :success="form.target_fisik_2 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_2 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Maret" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Maret
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_3"
                              :success="form.target_fisik_3 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_3 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="April" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              April
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_4"
                              :success="form.target_fisik_4 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_4 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Mei" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Mei
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_5"
                              :success="form.target_fisik_5 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_5 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Juni" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Juni
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_6"
                              :success="form.target_fisik_6 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_6 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Juli" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Juli
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_7"
                              :success="form.target_fisik_7 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_7 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Agustus" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Agustus
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_8"
                              :success="form.target_fisik_8 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_8 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="September" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              September
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_9"
                              :success="form.target_fisik_9 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_9 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Oktober" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Oktober
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_10"
                              :success="form.target_fisik_10 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_10 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="November" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              November
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_11"
                              :success="form.target_fisik_11 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_11 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3">
                          <ValidationProvider
                            name="Desember" 
                            rules="max_100:100"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Desember
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return (event.charCode >= 32 && event.charCode <= 57) && event.charCode != 46"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Contoh. 10"

                              suffix="%"

                              hide-details

                              v-model="form.target_fisik_12"
                              :success="form.target_fisik_12 !== '' && valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>

                                <div v-if="form.target_fisik_12 !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <div
                            class="body-2 font-weight-bold black--text">
                            #Penanggung Jawab 
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nama PPKOM" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Nama PPKOM
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Nama PPKOM"

                              hide-details

                              v-model="form.ppkom_name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.ppkom_name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nama PPTK" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Nama PPTK
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"    
                              placeholder="Nama PPTK"

                              hide-details

                              v-model="form.pptk_name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.pptk_name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                v-if="user.role === 'admin' ? true : $route.query.program_id === undefined && $route.query.kegiatan_id === undefined ? is_add_program : $route.query.program_id !== undefined && $route.query.kegiatan_id === undefined ? is_add_kegiatan : is_add_sub_kegiatan"
                :loading="process.form"
                :disabled="process.form"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/program-p1"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        menu: ['Program', 'Kegiatan', 'Sub Kegiatan'],

        list: {
          program: [],
          kegiatan: []
        },

        show_anggaran: false,
        show_fisik: false,
        select_program: false,
        is_add_program: false,
        is_add_kegiatan: false,
        is_add_sub_kegiatan: false,

        form: {
          // Field Bantu
          program_id: '',
          kegiatan_id: '',

          par_id: 0,
          par_name: '',
          code: '',
          title: '',
          type: 'Sub Kegiatan',
          type_index: 2,

          anggaran_before: 0,
          anggaran: 0,
          anggaran_p1: 0,
          anggaran_perubahan: 0,
          
          tahun_anggaran: Number(moment().format('YYYY')),
          tahun_anggaran_text: '',

          target_keu_1: 0,
          target_keu_2: 0,
          target_keu_3: 0,
          target_keu_4: 0,
          target_keu_5: 0,
          target_keu_6: 0,
          target_keu_7: 0,
          target_keu_8: 0,
          target_keu_9: 0,
          target_keu_10: 0,
          target_keu_11: 0,
          target_keu_12: 0,

          target_fisik_1: 0,
          target_fisik_2: 0,
          target_fisik_3: 0,
          target_fisik_4: 0,
          target_fisik_5: 0,
          target_fisik_6: 0,
          target_fisik_7: 0,
          target_fisik_8: 0,
          target_fisik_9: 0,
          target_fisik_10: 0,
          target_fisik_11: 0,
          target_fisik_12: 0,

          realisasi_keu_1: 0,
          realisasi_keu_2: 0,
          realisasi_keu_3: 0,
          realisasi_keu_4: 0,
          realisasi_keu_5: 0,
          realisasi_keu_6: 0,
          realisasi_keu_7: 0,
          realisasi_keu_8: 0,
          realisasi_keu_9: 0,
          realisasi_keu_10: 0,
          realisasi_keu_11: 0,
          realisasi_keu_12: 0,

          realisasi_fisik_1: 0,
          realisasi_fisik_2: 0,
          realisasi_fisik_3: 0,
          realisasi_fisik_4: 0,
          realisasi_fisik_5: 0,
          realisasi_fisik_6: 0,
          realisasi_fisik_7: 0,
          realisasi_fisik_8: 0,
          realisasi_fisik_9: 0,
          realisasi_fisik_10: 0,
          realisasi_fisik_11: 0,
          realisasi_fisik_12: 0,

          ppkom_name: '',
          pptk_name: '',

          is_excluded: 'tidak',
          dpa_status: 'p1'
        },

        process: {
          form: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.type': function() {
        this.form.anggaran_before = 0
      },

      'form.program_id': function() {
        let t = this
        // Jangan ambil anggaran_before dari program kalau lagi isi dari query (pakai dari fetchKegiatan)
        if (this._loadingFromQuery) return

        let p = this.list.program.filter(function(v) {
          return t.form.program_id == v.id
        })

        if (p.length > 0 && this.form.type === 'Kegiatan') {
          this.form.anggaran_before = p[0].anggaran_p1
          
          this.form.code = `${p[0].code}.`
        }
      },

      'form.kegiatan_id': function() {
        let t = this

        let k = this.list.kegiatan.filter(function(v) {
          return t.form.kegiatan_id == v.id
        })

        if (k.length > 0 && this.form.type === 'Sub Kegiatan') {
          this.form.anggaran_before = k[0].anggaran_p1

          this.form.anggaran = k[0].anggaran
          this.form.code = `${k[0].code}.`
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.applyQueryParams()
      this.fetch()
    },
    methods: {
      applyQueryParams () {
        const q = this.$route.query
        if (q.year) {
          const y = parseInt(q.year, 10)
          if (!isNaN(y)) this.form.tahun_anggaran = y
        }
        // program_id & kegiatan_id dari query, akan di-set ke form setelah data di-load (agar tipe id cocok)
        if (q.program_id !== undefined && q.program_id !== '') {
          this.form.program_id = q.program_id
        }
        if (q.kegiatan_id !== undefined && q.kegiatan_id !== '') {
          this.form.kegiatan_id = q.kegiatan_id
        }
        // type_index: 1 = Kegiatan (program_id ada, kegiatan_id undefined), 2 = Sub Kegiatan (program_id & kegiatan_id ada)
        const hasProgram = q.program_id !== undefined && q.program_id !== ''
        const hasKegiatan = q.kegiatan_id !== undefined && q.kegiatan_id !== ''
        if (hasProgram && hasKegiatan) {
          this.form.type = 'Sub Kegiatan'
          this.form.type_index = 2
        } else if (hasProgram) {
          this.form.type = 'Kegiatan'
          this.form.type_index = 1
        }
      },

      async fetch () {
        await this.fetchProgram()
        // Set program_id dari item yang ada di list (tipe id persis dari API) supaya v-autocomplete ke-isi
        const q = this.$route.query
        if (q.program_id !== undefined && q.program_id !== '' && this.list.program.length) {
          const program = this.list.program.find(p => p.id == q.program_id)
          if (program) {
            this.form.program_id = program.id
            this.is_add_kegiatan = program.is_editable === '1' ? true : false
            // Tipe Kegiatan (hanya program_id dari query): set dari program karena watcher jalan saat list.program masih kosong
            const hasKegiatanInQuery = q.kegiatan_id !== undefined && q.kegiatan_id !== ''
            if (!hasKegiatanInQuery && this.form.type === 'Kegiatan') {
              this.form.anggaran_before = program.anggaran_p1 != null ? program.anggaran_p1 : 0
              this.form.code = program.code ? `${program.code}.` : ''
            }
          }
        }
        if (this.form.program_id) {
          await this.fetchKegiatan()
          // Set kegiatan_id dari item yang ada di list (tipe id persis dari API) supaya v-autocomplete ke-isi
          if (q.kegiatan_id !== undefined && q.kegiatan_id !== '' && this.list.kegiatan.length) {
            const kegiatan = this.list.kegiatan.find(k => k.id == q.kegiatan_id)
            if (kegiatan) {
              this.form.kegiatan_id = kegiatan.id
              this.is_add_sub_kegiatan = kegiatan.is_editable === '1' ? true : false
              // anggaran_before dari anggaran_p1 kegiatan (watcher tidak jalan kalau nilai sama)
              this.form.anggaran_before = kegiatan.anggaran_p1 != null ? kegiatan.anggaran_p1 : 0
              this.form.anggaran = kegiatan.anggaran != null ? kegiatan.anggaran : 0
              this.form.code = kegiatan.code ? `${kegiatan.code}.` : ''
            }
          }
        }
      },

      async fetchProgram () {
        let params = {
          limit: 100000,
          type: 'Program',

          unit_id: this.$route.query.unit_id,
          tahun_anggaran: this.form.tahun_anggaran,
          dpa_status: 'p1'
        }

        await get('admin/task/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // this.list.program = this.changeData(res.results.data)

            this.list.program = res.results.data
          }
        })
      },

      async fetchKegiatan () {
        let params = {
          limit: 100000,
          par_id: this.form.program_id,

          unit_id: this.$route.query.unit_id,
          tahun_anggaran: this.form.tahun_anggaran,
          dpa_status: 'p1'
        }

        await get('admin/task/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.list.kegiatan = res.results.data
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      to_value (val) {
        let data = val[0]

        this.form.par_id = data.id
        this.form.par_name = data.title

        this.select_program = false
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          this.form.par_id = this.form.type === 'Program' ? 0 : this.form.type === 'Kegiatan' ? this.form.program_id : this.form.kegiatan_id

          // SAVE TO REST API
          await post(`admin/task/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/program-p1' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>